import { render, staticRenderFns } from "./PartnerAdd.vue?vue&type=template&id=5a2d5005"
import script from "./PartnerAdd.vue?vue&type=script&lang=js"
export * from "./PartnerAdd.vue?vue&type=script&lang=js"
import style0 from "./PartnerAdd.vue?vue&type=style&index=0&id=5a2d5005&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports